import script from "./ReservationDialogSeat.vue?vue&type=script&setup=true&lang=js"
export * from "./ReservationDialogSeat.vue?vue&type=script&setup=true&lang=js"

import "./ReservationDialogSeat.vue?vue&type=style&index=0&id=2b34022d&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2b34022d"]])

export default __exports__